import React from 'react';
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import { useTheme } from "../../context/ThemeContext";

const TransliteratedInput = ({
    value,
    onChangeText,
    lang = "mr",
    placeholder = "Type here...",
    className = "",
    type = "text",
    as = "input",
    ...props
}) => {
    const { isTransliterationEnabled, toggleTransliteration } = useTheme();

    const handleKeyDown = (e) => {
        // Toggle transliteration globally with Ctrl+M
        if ((e.ctrlKey || e.metaKey) && (e.key === 'm' || e.key === 'M')) {
            e.preventDefault();
            toggleTransliteration();
            return;
        }

        // Let the original onKeyDown handler run if it exists
        if (props.onKeyDown) {
            props.onKeyDown(e);
        }
    };

    return (
        <div className="transliterate-wrapper">
            <ReactTransliterate
                enabled={isTransliterationEnabled}
                value={value}
                onChangeText={onChangeText}
                lang={lang}
                placeholder={placeholder}
                renderComponent={(inputProps) => {
                    const Component = as === "textarea" ? "textarea" : "input";
                    const { onKeyDown: libOnKeyDown, ...restLibProps } = inputProps;

                    return (
                        <div className="input-with-toggle">
                            <Component
                                {...props}
                                {...restLibProps}
                                onKeyDown={(e) => {
                                    handleKeyDown(e);
                                    if (libOnKeyDown) libOnKeyDown(e);
                                }}
                                type={Component === "input" ? type : undefined}
                                className={className}
                                style={{
                                    ...props.style,
                                }}
                            />
                        </div>
                    );
                }}
                containerClassName="transliterate-container"
            />
        </div>
    );
};

export default TransliteratedInput;
